<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_CONTRACTS"
    title="Contracts"
    :breadcrumbs="breadcrumbs"
    action-button-text="Create Contract"
    page-name="Contracts"
    align="center"
    width="full"
    @click:action="openCreateModal"
  >
    <SmartFeed
      :source="useContractFeedStore"
      default-feed-layout="table"
    >
      <template #empty-state>
        <iSpace :height="50" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No Contracts Yet
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              When you create or join contracts, they'll appear here for easy access and management
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>

    <CreateContractModal
      :is-open="isCreateModalOpen"
      @update:is-open="isCreateModalOpen = $event"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { PAGE_PUBLICATION_CONTRACTS, SECTION_PUBLICATIONS } from "@/constants/nav-constants";
import { useContractFeedStore } from "@/smart-feed/stores/feed/contract-feed-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import CreateContractModal from "@/smart-feed/components/contract/CreateContractModal.vue";

export default {
  name: "MyContracts",
  components: {
    CreateContractModal,
    SmartFeed,
    PageWrapper,
  },
  props: {
    orgId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_PUBLICATION_CONTRACTS,
      isCreateModalOpen: false,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}/overview`, label: "Publications" },
        { label: "Contracts" },
      ];
    },
  },
  methods: {
    useContractFeedStore,
    openCreateModal() {
      this.isCreateModalOpen = true;
    },
  },
};
</script>
